import React, { useState } from 'react'
import { Text, List, TabPane, Dialog, Content } from '@leverege/ui-elements'
import S from './ImportResults.css'

export default function ImportResults( props ) {

  const { notes = [], errors = [], project } = props
  
  const pView = <Text className={S.msg}>Project {project.name} ({project.id}) was imported</Text>
  const nView = ( 
    <TabPane.Tab tabName={`Notes(${notes.length})`} tabId="notes">
      <DetailedList items={notes} noItemString="No Notes" selector={useSelector( notes )}/>
    </TabPane.Tab>
  )   
  const eView = (
    <TabPane.Tab tabName={`Errors(${errors.length})`} tabId="errors">
      <DetailedList items={errors} noItemString="No Errors" selector={useSelector( errors )}/>
    </TabPane.Tab>
  )

  if ( nView || eView ) {
    return (
      <div className={S.pane}>
        {pView}
        <TabPane className={S.tab}>
          {nView}
          {eView}
        </TabPane>
      </div>
    )
  }

  return pView
}

function useSelector( items ) {
  const [ selected, setSelected ] = useState( null )

  const selector = {
    getSelected( ) { return selected },
    isSelected( item ) { return item === selected },
    onSelect( evt ) { setSelected( evt.value ) }
  }
  return selector
}

function DetailedList( props ) {
  const { items, noItemString, selector } = props
  const selected = selector.getSelected()
  const hasItems = items.length > 0

  if ( !hasItems ) {
    return <Text className={S.noItems}>{noItemString}</Text>
  }

  const detail = selected ? JSON.stringify( selected, null, 2 ) : 'Select an Item'
  return (
    <Content horizontal>
      <Content.Header>
        <List selector={selector} className={S.itemList} >
          { 
            items.map( ( itm, idx ) => {
              // eslint-disable-next-line react/no-array-index-key
              return <List.Item key={`${itm.message} ${idx}`} item={itm}>{itm.message}</List.Item> 
            } ) 
          }
        </List>
      </Content.Header>
      <Content.Area>
        <div className={S.details}>
          <pre className={S.detailsText}>{detail}</pre>
        </div>
      </Content.Area>
    </Content>
  )
}

ImportResults.Dialog = function( { show, onClose, project, errors, notes, okay, cancel, onOkay, onCancel } ) {
  return (
    <Dialog.Question 
      variant="largeDialogBody"
      className={S.dialog}
      bodyClassName={S.dialogBody}
      style={{ minWidth : '80vw', minHeight : '80vh' }}
      title="Project Results"
      show={show}
      onOkay={onOkay}
      okay={okay}
      onCancel={onCancel}
      cancel={cancel}
      onClose={onClose}>
      <ImportResults project={project} errors={errors} notes={notes}/>
    </Dialog.Question>
  )
}
